var map = {
	"./amex.svg": 134,
	"./apple-icon.svg": 9751,
	"./arrow-down-icon.svg": 8520,
	"./arrow-right-icon.svg": 6209,
	"./avatar-icon.svg": 772,
	"./back-arrow-icon.svg": 2432,
	"./close-icon.svg": 3997,
	"./copy-icon.svg": 110,
	"./edit-icon.svg": 438,
	"./email-icon.svg": 8692,
	"./empty-state-icon.svg": 1198,
	"./error-icon.svg": 7684,
	"./facebook-icon.svg": 8941,
	"./facebook-tertiary-icon.svg": 9103,
	"./google-icon.svg": 1421,
	"./info-icon.svg": 3309,
	"./info-sm-icon.svg": 2018,
	"./instagram-tertiary-icon.svg": 860,
	"./link-icon.svg": 9172,
	"./linkedin-tertiary-icon.svg": 7642,
	"./mastercard.svg": 174,
	"./menu-icon.svg": 8054,
	"./modal-close-icon.svg": 9013,
	"./primary-arrow-left-icon.svg": 2000,
	"./regional-icon.svg": 7535,
	"./search-icon-sm.svg": 8417,
	"./search-icon.svg": 4609,
	"./shield-icon.svg": 3380,
	"./spinner.svg": 6057,
	"./success-icon.svg": 4190,
	"./trash-icon.svg": 1967,
	"./twitter-tertiary-icon.svg": 5487,
	"./visa.svg": 5593,
	"./world-icon.svg": 3014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;